module.exports = __webpack_public_path__ + "public/img/vip-icon.30d90753.png";